(function() {
  'use strict';
  
  if (!document.body.classList.contains('template-product')) return;
  
  const CONFIG = {
    buttonEnableDelay: 1500,
    variantCheckInterval: 50,
    maxWaitTime: 2000,
    customElementWaitTime: 2000,
    enableLogging: false  // Set to true when debugging
  };
  
  function log(message, data) {
    if (CONFIG.enableLogging && typeof console !== 'undefined') {
      const timestamp = new Date().toISOString().split('T')[1].split('.')[0];
      if (data !== undefined) {
        console.log(`[${timestamp}] [VARIANT-PROTECTION]`, message, data);
      } else {
        console.log(`[${timestamp}] [VARIANT-PROTECTION]`, message);
      }
    }
  }
  
  let variantSelectorReady = false;
  let protectionActive = false;
  let expectedVariantId = null;
  let pendingSubmission = false;
  let lastSelectedVariantId = null;
  
  function initVariantProtection() {
    try {
      log('=== INITIALIZATION START ===');
      log('Document ready state:', document.readyState);
      log('Template class present:', document.body.classList.contains('template-product'));
      
      const productForms = document.querySelectorAll('product-form form[action*="/cart/add"]');
      log('Found product forms:', productForms.length);
      
      if (productForms.length === 0) {
        log('WARNING: No product forms found');
        return;
      }
      
      productForms.forEach(function(form, index) {
        log('Processing form', index + 1);
        waitForVariantRadios(form, function() {
          protectForm(form);
        });
      });
      
    } catch (error) {
      log('ERROR: Init error:', error);
      log('ERROR stack:', error.stack);
    }
  }
  
  function waitForVariantRadios(form, callback) {
    const startTime = Date.now();
    log('Waiting for variant radios...');
    
    function checkForRadios() {
      const radioButtons = form.querySelectorAll(
        'input[type="radio"][name="Size"], ' +
        'input.product-form__radio, ' +
        'variant-radios input[type="radio"]'
      );
      
      const elapsed = Date.now() - startTime;
      
      if (radioButtons.length > 0) {
        log('SUCCESS: Found', radioButtons.length, 'radio buttons after', elapsed, 'ms');
        callback();
        return;
      }
      
      if (elapsed > CONFIG.customElementWaitTime) {
        log('WARNING: Timeout waiting for radio buttons after', elapsed, 'ms');
        callback();
        return;
      }
      
      if (elapsed % 500 === 0) {
        log('Still waiting for radios...', elapsed, 'ms elapsed');
      }
      
      setTimeout(checkForRadios, 100);
    }
    
    checkForRadios();
  }
  
  function protectForm(form) {
    try {
      log('=== PROTECT FORM START ===');
      
      const hiddenVariantInput = form.querySelector('input[name="id"]');
      const variantSelect = form.querySelector('select[name="id"]');
      
      log('Hidden variant input found:', !!hiddenVariantInput);
      log('Variant select found:', !!variantSelect);
      
      let optionInputs = form.querySelectorAll(
        'input[type="radio"][name="Size"], ' +
        'input[type="radio"][name="Color"], ' +
        'input.product-form__radio'
      );
      
      if (optionInputs.length === 0) {
        log('No inputs in form, trying document query');
        optionInputs = document.querySelectorAll(
          'variant-radios input[type="radio"], ' +
          '.product-form__radio'
        );
      }
      
      log('Found', optionInputs.length, 'option inputs total');
      
      optionInputs.forEach(function(input, index) {
        log('Selector ' + index + ':', {
          name: input.name,
          value: input.value,
          checked: input.checked,
          variantId: input.getAttribute('data-variant-id')
        });
      });
      
      const initialVariantId = getVariantIdFromUrl() || 
                              (hiddenVariantInput ? hiddenVariantInput.value : null) ||
                              (variantSelect ? variantSelect.value : null);
      
      expectedVariantId = initialVariantId;
      lastSelectedVariantId = initialVariantId;
      
      log('Initial variant ID:', initialVariantId);
      log('Initial URL:', window.location.href);
      
      setupOptionTracking(form, optionInputs, hiddenVariantInput);
      
      const atcButtons = setupButtonProtection(form);
      log('ATC buttons to protect:', atcButtons.length);
      
      setupSubmissionProtection(form, hiddenVariantInput, variantSelect, optionInputs);
      
      log('Setting up auto-enable timeout:', CONFIG.buttonEnableDelay, 'ms');
      const enableTimeout = setTimeout(function() {
        log('=== AUTO-ENABLE TIMEOUT TRIGGERED ===');
        enableButtons(atcButtons);
        variantSelectorReady = true;
        protectionActive = true;
        log('Buttons should now be enabled. Check button state above.');
      }, CONFIG.buttonEnableDelay);
      
      form.addEventListener('change', function() {
        if (!protectionActive) {
          clearTimeout(enableTimeout);
          log('=== EARLY ENABLE (form changed before timeout) ===');
          enableButtons(atcButtons);
          protectionActive = true;
          variantSelectorReady = true;
        }
      }, { once: true });
      
      log('=== PROTECT FORM COMPLETE ===');
      
    } catch (error) {
      log('ERROR: Form protection error:', error);
      log('ERROR stack:', error.stack);
    }
  }
  
  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }
  
  function setupOptionTracking(form, optionInputs, hiddenVariantInput) {
    try {
      log('=== SETUP OPTION TRACKING ===');
      let variantUpdatePending = false;
      
      document.addEventListener('change', function(e) {
        const target = e.target;
        if (target && target.type === 'radio' && target.name === 'Size') {
          variantUpdatePending = true;
          
          const dataVariantId = target.getAttribute('data-variant-id');
          
          if (dataVariantId) {
            expectedVariantId = dataVariantId;
            log('CHANGE: Size selected:', target.value, 'Expected variant:', dataVariantId);
            log('STATUS: Variant update PENDING (waiting for Ella theme)');
          }
        }
      }, true);
      
      if (hiddenVariantInput) {
        log('Setting up hidden input listener');
        hiddenVariantInput.addEventListener('change', function(e) {
          if (variantUpdatePending) {
            lastSelectedVariantId = hiddenVariantInput.value;
            variantSelectorReady = true;
            variantUpdatePending = false;
            
            log('CHANGE: Hidden input updated by Ella:', hiddenVariantInput.value);
            log('STATUS: Variant update COMPLETE - ready for submission');
          }
        }, false);
        
        if (typeof MutationObserver !== 'undefined') {
          log('Setting up MutationObserver for hidden input');
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                const newValue = hiddenVariantInput.value;
                if (newValue && newValue !== mutation.oldValue) {
                  lastSelectedVariantId = newValue;
                  expectedVariantId = newValue;
                  
                  if (variantUpdatePending) {
                    variantUpdatePending = false;
                    log('MUTATION: Hidden input updated:', newValue);
                    log('STATUS: Variant update COMPLETE');
                  }
                }
              }
            });
          });
          
          observer.observe(hiddenVariantInput, {
            attributes: true,
            attributeOldValue: true
          });
        }
      } else {
        log('WARNING: No hidden variant input found for tracking');
      }
      
      optionInputs.forEach(function(input) {
        if (!input) return;
        
        input.addEventListener('change', function(e) {
          variantSelectorReady = true;
          variantUpdatePending = true;
          
          const dataVariantId = e.target.getAttribute('data-variant-id');
          
          if (dataVariantId) {
            expectedVariantId = dataVariantId;
            log('CHANGE: Direct listener - Size:', e.target.value, 'Variant:', dataVariantId);
          }
        }, true);
      });
      
      log('Option tracking setup complete');
      
    } catch (error) {
      log('ERROR: Option tracking error:', error);
      log('ERROR stack:', error.stack);
    }
  }
  
  function setupButtonProtection(form) {
    try {
      log('=== SETUP BUTTON PROTECTION ===');
      
      const selectors = [
        'button[type="submit"][name="add"]',
        'button.productView-btn-cart',
        '.product-form__submit',
        'button[data-add-to-cart]'
      ];
      
      log('Searching for buttons with selectors:', selectors.join(', '));
      
      const atcButtons = form.querySelectorAll(selectors.join(','));
      
      log('Found', atcButtons.length, 'buttons to protect');
      
      atcButtons.forEach(function(button, index) {
        if (!button) {
          log('WARNING: Button', index, 'is null');
          return;
        }
        
        log('Button', index, 'current state:', {
          disabled: button.disabled,
          text: button.textContent.trim(),
          classes: button.className,
          innerHTML: button.innerHTML
        });
        
        button.disabled = true;
        button.classList.add('is-loading');
        
        // CRITICAL FIX: Check if inline script already saved original text
        if (!button.dataset.originalText) {
          var currentText = button.textContent ? button.textContent.trim() : '';
          
          // If button says "Loading...", use default
          if (currentText.toLowerCase() === 'loading...' || 
              currentText.toLowerCase() === 'loading' || 
              !currentText) {
            button.dataset.originalText = 'Add to cart';
            log('No original text found (was "Loading..."), using default: Add to cart');
          } else {
            button.dataset.originalText = currentText;
            log('Saved original text:', button.dataset.originalText);
          }
        } else {
          log('Original text already saved by inline script:', button.dataset.originalText);
        }
        
        log('Button', index, 'after protection:', {
          disabled: button.disabled,
          text: button.textContent.trim(),
          hasLoadingClass: button.classList.contains('is-loading'),
          savedOriginalText: button.dataset.originalText
        });
      });
      
      return atcButtons;
      
    } catch (error) {
      log('ERROR: Button protection error:', error);
      log('ERROR stack:', error.stack);
      return [];
    }
  }
  
  function enableButtons(buttons) {
    try {
      log('=== ENABLE BUTTONS CALLED ===');
      log('Number of buttons to enable:', buttons.length);
      
      if (buttons.length === 0) {
        log('ERROR: No buttons to enable!');
        return;
      }
      
      buttons.forEach(function(button, index) {
        if (!button) {
          log('WARNING: Button', index, 'is null, skipping');
          return;
        }
        
        log('Enabling button', index);
        log('Before enable:', {
          disabled: button.disabled,
          text: button.textContent.trim(),
          originalText: button.dataset.originalText,
          originalHtml: button.dataset.originalHtml,
          innerHTML: button.innerHTML
        });
        
        button.disabled = false;
        button.classList.remove('is-loading');
        button.style.opacity = '';
        button.style.cursor = '';
        
        // CRITICAL FIX: Use originalHTML if originalText is "Loading..."
        var originalText = button.dataset.originalText;
        
        if (originalText && originalText.toLowerCase() === 'loading...') {
          // originalText is wrong, try originalHTML or use default
          if (button.dataset.originalHtml) {
            originalText = button.dataset.originalHtml;
            log('originalText was "Loading...", using originalHTML:', originalText);
          } else {
            originalText = 'Add to cart';
            log('originalText was "Loading...", using default: Add to cart');
          }
        }
        
        if (originalText) {
          var btnTextSpan = button.querySelector('.btn-text');
          
          if (btnTextSpan) {
            // Ella theme - update the span to preserve structure
            btnTextSpan.textContent = originalText;
            log('Updated .btn-text span to:', originalText);
          } else {
            // No span structure - update button directly
            button.textContent = originalText;
            log('Updated button.textContent to:', originalText);
          }
        }
        
        log('After enable:', {
          disabled: button.disabled,
          text: button.textContent.trim(),
          hasLoadingClass: button.classList.contains('is-loading'),
          innerHTML: button.innerHTML
        });
      });
      
      log('=== ENABLE BUTTONS COMPLETE ===');
      
    } catch (error) {
      log('ERROR: Button enable error:', error);
      log('ERROR stack:', error.stack);
    }
  }
  
  function setupSubmissionProtection(form, hiddenVariantInput, variantSelect, optionInputs) {
    try {
      log('=== SETUP SUBMISSION PROTECTION ===');
      
      form.addEventListener('submit', handleSubmit, true);
      
      const originalFetch = window.fetch;
      window.fetch = function(url, options) {
        if (url && url.includes('/cart/add')) {
          log('INTERCEPT: Fetch to /cart/add detected');
          return validateAndFetch(url, options, originalFetch, hiddenVariantInput);
        }
        return originalFetch.apply(this, arguments);
      };
      
      function handleSubmit(e) {
        log('SUBMIT: Form submission intercepted');
        
        if (!variantSelectorReady) {
          e.preventDefault();
          e.stopImmediatePropagation();
          log('BLOCKED: Selector not ready');
          
          if (typeof alert !== 'undefined') {
            alert('Please wait a moment while the page loads, then try again.');
          }
          return false;
        }
        
        const currentVariantId = hiddenVariantInput ? hiddenVariantInput.value : 
                                 variantSelect ? variantSelect.value : null;
        
        log('CHECK: Submission check:', {
          currentVariantId: currentVariantId,
          lastSelected: lastSelectedVariantId,
          expected: expectedVariantId
        });
        
        const checkedRadio = document.querySelector('input[name="Size"]:checked');
        if (checkedRadio) {
          const checkedVariantId = checkedRadio.getAttribute('data-variant-id');
          log('CHECK: Checked radio:', checkedRadio.value, 'Variant:', checkedVariantId);
          
          if (checkedVariantId && currentVariantId !== checkedVariantId) {
            e.preventDefault();
            e.stopImmediatePropagation();
            log('BLOCKED: Mismatch - Checked:', checkedVariantId, 'Hidden:', currentVariantId);
            
            if (pendingSubmission) {
              return false;
            }
            
            pendingSubmission = true;
            waitForVariantSync(form, checkedVariantId, hiddenVariantInput);
            return false;
          }
        }
        
        if (lastSelectedVariantId && lastSelectedVariantId !== currentVariantId) {
          e.preventDefault();
          e.stopImmediatePropagation();
          log('BLOCKED: Last selected mismatch');
          
          if (pendingSubmission) {
            return false;
          }
          
          pendingSubmission = true;
          waitForVariantSync(form, lastSelectedVariantId, hiddenVariantInput);
          return false;
        }
        
        log('SUCCESS: Submission allowed with variant:', currentVariantId);
      }
      
      function validateAndFetch(url, options, originalFetch, hiddenInput) {
        const currentVariantId = hiddenInput ? hiddenInput.value : null;
        
        const checkedRadio = document.querySelector('input[name="Size"]:checked');
        const checkedVariantId = checkedRadio ? checkedRadio.getAttribute('data-variant-id') : null;
        
        log('AJAX CHECK: Hidden input variant:', currentVariantId);
        log('AJAX CHECK: Checked radio variant:', checkedVariantId);
        log('AJAX CHECK: Last selected variant:', lastSelectedVariantId);
        
        if (checkedVariantId && currentVariantId !== checkedVariantId) {
          log('AJAX BLOCKED: Checked radio mismatch - ABORTING original request');
          
          return new Promise(function(resolve, reject) {
            const startTime = Date.now();
            const maxWait = CONFIG.maxWaitTime;
            
            const checkInterval = setInterval(function() {
              const newVariantId = hiddenInput ? hiddenInput.value : null;
              const elapsed = Date.now() - startTime;
              
              if (newVariantId === checkedVariantId) {
                clearInterval(checkInterval);
                log('AJAX RETRY: Variant synced after', elapsed, 'ms - creating new request');
                
                const newOptions = createNewRequest(options, checkedVariantId);
                resolve(originalFetch(url, newOptions));
                return;
              }
              
              if (elapsed > maxWait) {
                clearInterval(checkInterval);
                log('AJAX TIMEOUT: Creating NEW request with correct variant after', elapsed, 'ms');
                
                const newOptions = createNewRequest(options, checkedVariantId);
                resolve(originalFetch(url, newOptions));
                return;
              }
              
              if (elapsed % 200 === 0) {
                log('AJAX WAIT: Still waiting...', elapsed, 'ms');
              }
            }, 50);
          });
        }
        
        if (lastSelectedVariantId && currentVariantId !== lastSelectedVariantId) {
          log('AJAX BLOCKED: Last selected mismatch - ABORTING original request');
          
          return new Promise(function(resolve) {
            const startTime = Date.now();
            const maxWait = CONFIG.maxWaitTime;
            
            const checkInterval = setInterval(function() {
              const newVariantId = hiddenInput ? hiddenInput.value : null;
              const elapsed = Date.now() - startTime;
              
              if (newVariantId === lastSelectedVariantId) {
                clearInterval(checkInterval);
                log('AJAX RETRY: Variant synced to last selected after', elapsed, 'ms');
                
                const newOptions = createNewRequest(options, lastSelectedVariantId);
                resolve(originalFetch(url, newOptions));
                return;
              }
              
              if (elapsed > maxWait) {
                clearInterval(checkInterval);
                log('AJAX TIMEOUT: Proceeding with current:', newVariantId);
                resolve(originalFetch(url, options));
                return;
              }
              
              if (elapsed % 200 === 0) {
                log('AJAX WAIT: Still waiting...', elapsed, 'ms');
              }
            }, 50);
          });
        }
        
        log('AJAX ALLOWED: Proceeding with original request');
        return originalFetch(url, options);
      }
      
      function createNewRequest(originalOptions, correctVariantId) {
        log('CREATE: Building fresh request with variant:', correctVariantId);
        
        try {
          const newOptions = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: correctVariantId,
              quantity: 1
            })
          };
          
          log('CREATE: New request body:', newOptions.body);
          return newOptions;
          
        } catch (error) {
          log('ERROR: Could not create new request:', error);
          return originalOptions;
        }
      }
      
    } catch (error) {
      log('ERROR: Submission protection error:', error);
      log('ERROR stack:', error.stack);
    }
  }
  
  function waitForVariantSync(form, targetVariantId, hiddenInput) {
    const startTime = Date.now();
    log('WAIT: Syncing to variant:', targetVariantId);
    
    const checkInterval = setInterval(function() {
      const currentVariantId = hiddenInput ? hiddenInput.value : null;
      const elapsed = Date.now() - startTime;
      
      if (currentVariantId === targetVariantId) {
        clearInterval(checkInterval);
        pendingSubmission = false;
        log('SUCCESS: Variant synced');
        
        try {
          form.submit();
        } catch(error) {
          log('ERROR: Submit failed:', error);
        }
        return;
      }
      
      if (elapsed > CONFIG.maxWaitTime) {
        clearInterval(checkInterval);
        pendingSubmission = false;
        log('TIMEOUT: Submitting anyway');
        
        try {
          form.submit();
        } catch(error) {
          log('ERROR: Submit failed:', error);
        }
        return;
      }
      
      if (elapsed % 200 === 0) {
        log('WAIT: Current:', currentVariantId, 'Target:', targetVariantId);
      }
      
    }, CONFIG.variantCheckInterval);
  }
  
  var initialized = false;
  
  function safeInit() {
    if (!initialized) {
      initialized = true;
      log('=======================================================');
      log('=== VARIANT PROTECTION SYSTEM STARTING ===');
      log('=== Time:', new Date().toISOString());
      log('=======================================================');
      initVariantProtection();
    }
  }
  
  if (document.readyState === 'loading') {
    log('Document still loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    log('Document already loaded, initializing immediately');
    safeInit();
  }
  
})();
